import styled from "@emotion/styled";
import { QuestsModel, WorkflowsJourney } from "../../../../../Models/Quests/Quests.Model";
import { useState } from "react";
import { QuestModelHelper } from "../../../../../Models/Quests/Helpers/QuestModel.Helper";
import { InheritanceStatus,QuestType } from "@swivl-mono/types";
import { Member } from "../../../../../Models/Member/Member.Current";
import { Spinner } from "@swivl-mono/ui";

interface Props {
    workflowJourney: WorkflowsJourney;
}
const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0 8px 12px 8px;
    opacity: 0;
    transition: opacity 0.2s ease;
`;

// const AddQuest = styled.div`
//     background-color: #F0ECE9;
//     flex:1; 
//     border: 2px dashed #C3BCB9;
//     border-radius: 8px;
//     margin-right: 12px;
//     height:45px;
//     cursor: pointer;
//     `;

const AddButtonDiv = styled.div`
    font-size: 14px;
    background-color: none;
    flex:1; 
    border: 1px dashed #6C6C6C;
    height:45px;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #413B38;
    transition: all 0.3s ease;

    &:hover {
        background-color: #FFEFE6;
        color: #FF5B02;
        border-color: #FF5B02;
    }
    $:active {
        color:#5E5450;
        border-color: #5E5450;
    }

    `;

interface AddButtonProps {
    children: string;
    isMatrix?: boolean;
    workflowJourney?: WorkflowsJourney;
}
function AddButton(props: AddButtonProps) {
    const [isLoading, setIsLoading] = useState(false);
    return <AddButtonDiv
        style={props.isMatrix ? { "borderRadius": "8px 8px 8px 22px", "margin": "0 0 0 12px" } : {}}
        onClick={async () => {
            setIsLoading(true);
            const name = props.isMatrix ? "New Matrix" : "New Quest"
            const type = props.isMatrix ? QuestType.MATRIX : QuestType.NORMAL;
            let inheritance: InheritanceStatus = InheritanceStatus.NONE;

            if (Member.isInChildOrg) {
                inheritance = InheritanceStatus.NONE;
            }
            let newQuest = QuestModelHelper.newQuest(name, type, props.workflowJourney!.journey!.slug!, inheritance, props.workflowJourney?.quests.length);
            await QuestsModel.createQuest(newQuest);

            setIsLoading(false);
        }}>
        {isLoading ? <Spinner /> : props.children}
    </AddButtonDiv>
}



export default function AddQuestButtons(props: Props) {
    const { workflowJourney } = props;
    const addQuest = () => {

    }

    return <Wrapper className="AddQuestButtons">
        <AddButton workflowJourney={workflowJourney}>+ New Quest</AddButton>
        <AddButton isMatrix={true} workflowJourney={workflowJourney}>+ New Matrix</AddButton>

    </Wrapper>
}